import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import { APIV2 } from 'services/ApiServiceV2';

export const getFavProducts = createAsyncThunk(
  'home/getFavProducts',
  async (arg, thunkAPI) => {
    const controller = new AbortController();
    const signal = controller.signal;
    return await APIV2(
      'get/allProducts/v2',
      'POST',
      {
        ...{
          optionId: 5,
        },
        userId:
          thunkAPI.getState().AuthReducer.userId ||
          thunkAPI.getState().AuthReducer.guestUserId,
      },
      'NODE',
      signal,
    )
      .then(res => {
        return res;
      })
      .catch(err => {
        return err;
      });
  },
);

export const getDislikedProducts = createAsyncThunk(
  'home/getDislikedProducts',
  async (arg, thunkAPI) => {
    return await APIV2(
      `dislikeProducts?userId=${
        thunkAPI.getState().AuthReducer.userId ||
        thunkAPI.getState().AuthReducer.guestUserId
      }`,
      'GET',
    )
      .then(res => {
        return res;
      })
      .catch(err => {
        return err;
      });
  },
);

export const dislikeproduct = createAsyncThunk(
  'home/dislikeproduct',
  async (arg, thunkAPI) => {
    return await APIV2(`dislikeProducts`, 'POST', {
      userId:
        thunkAPI.getState().AuthReducer.userId ||
        thunkAPI.getState().AuthReducer.guestUserId,
      productId: arg?.productId,
      isDisliked: arg?.isDisliked,
    })
      .then(res => {
        return res;
      })
      .catch(err => {
        return err;
      });
  },
);

let initialState = {
  favouriteProductIds: [],
  dislikeProductIds: [],
};

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setFavouriteProductIds: (state, action) => {
      state.guestUserId = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getFavProducts.pending, (state, action) => {})
      .addCase(getFavProducts.fulfilled, (state, action) => {
        if (
          [200].includes(action.payload.status) &&
          Array.isArray(action.payload?.data?.data?.productDetails)
        ) {
          state.favouriteProductIds =
            action.payload?.data?.data?.productDetails?.map(
              o => o?.productId || o?._id,
            );
        }
      })
      .addCase(getFavProducts.rejected, (state, action) => {
        console.log('getFavProducts api error', action?.payload);
      })
      .addCase(getDislikedProducts.pending, (state, action) => {})
      .addCase(getDislikedProducts.fulfilled, (state, action) => {
        if (
          [200].includes(action.payload.status) &&
          Array.isArray(action.payload?.data?.data?.[0]?.productIds)
        ) {
          state.dislikeProductIds = action.payload?.data?.data?.[0]?.productIds;
        }
      })
      .addCase(getDislikedProducts.rejected, (state, action) => {
        console.log('getDislikedProducts api error', action?.payload);
      })

      .addCase(dislikeproduct.pending, (state, action) => {})
      .addCase(dislikeproduct.fulfilled, (state, action) => {
        if (
          [200].includes(action.payload.status) &&
          Array.isArray(action.payload?.data?.data?.productIds)
        ) {
          state.dislikeProductIds = action.payload?.data?.data?.productIds;
        }
      })
      .addCase(dislikeproduct.rejected, (state, action) => {
        console.log('dislikeproduct api error', action?.payload);
      });
  },
});

export const {setFavouriteProductIds} = productSlice.actions;

export default productSlice.reducer;
